import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-start",
  "use": "foquz-icon-start-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" id=\"foquz-icon-start\"><path d=\"M17 9A7.999 7.999 0 111.002 9 7.999 7.999 0 0117 9h0z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /><path d=\"M7.031 6l5 3-5 3V6z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol